import axios from 'axios';
import { TTSVoice, TTSRequest } from '../types';
import { fetchGoogleVoices, synthesizeGoogleSpeech } from './googleTts';
import { fetchAzureVoices, synthesizeAzureSpeech } from './azureTts';
import { retryWithBackoff, serializeError } from '../utils/apiUtils';
import testAzureTts, { testAzureVoicesList } from '../utils/testAzureTts';

// Test Azure TTS API on startup
console.log('Testing Azure TTS API connectivity...');
Promise.all([
  testAzureTts(),
  testAzureVoicesList()
]).then(([ttsResult, voicesResult]) => {
  console.log('Azure API test results:', {
    tts: ttsResult ? 'Success' : 'Failed',
    voices: voicesResult ? 'Success' : 'Failed'
  });
}).catch(error => {
  console.error('Azure API test error:', serializeError(error));
});

// Lazy load Azure TTS to reduce main bundle size
const loadAzureTts = () => import('./azureTts');

export const fetchVoices = async (): Promise<TTSVoice[]> => {
  try {
    const [googleVoices, azureVoices] = await Promise.all([
      fetchGoogleVoices().catch(error => {
        console.error('Failed to fetch Google voices:', serializeError(error));
        return [];
      }),
      fetchAzureVoices().catch(error => {
        console.error('Failed to fetch Azure voices:', serializeError(error));
        return [];
      })
    ]);

    return [...googleVoices, ...azureVoices];
  } catch (error) {
    console.error('Error fetching voices:', serializeError(error));
    throw error;
  }
};

export const synthesizeSpeech = async (userId: string, request: TTSRequest): Promise<string> => {
  try {
    if (request.voice.provider === 'azure') {
      return await synthesizeAzureSpeech(request);
    } else {
      return await synthesizeGoogleSpeech(request);
    }
  } catch (error) {
    console.error('Speech synthesis failed:', {
      error: serializeError(error),
      provider: request.voice.provider,
      voiceId: request.voice.id
    });
    throw error;
  }
};

export const synthesizeWithAzure = async (request: TTSRequest) => {
  const azureTts = await loadAzureTts();
  return azureTts.synthesizeAzureSpeech(request);
};